import styled from "styled-components";

/**
 * Keep parent toolbar gap at 8px for spacing.
 * Use border (not width+background) so the 1px line stays crisp and
 * equal weight regardless of subpixel position. Color #bcbcbc matches
 * table borders and stays visible next to the gray mode-switch pill.
 */
export const Separator = styled.div<{ $height: number }>`
  display: inline-block;
  width: 0;
  height: ${({ $height }) => $height}px;
  border-left: 1px solid #bcbcbc;
  background: none;
  flex-shrink: 0;
  align-self: center;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;
